export default "__VITE_ASSET__DIeyDjmD__"